import { makeStyles } from "@material-ui/styles";

export const useSuspendedBillStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
    },
    dialogMainTitle: {
      fontWeight: "bolder",
      fontSize: "1.3rem",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    dialogSubTitleArabic: {
      fontWeight: "bold",
      fontSize: "0.99rem",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    dialogSubTitle: {
      fontWeight: "bold",
      fontSize: "0.845rem",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    dialogMainTitleArabic: {
      fontWeight: "bolder",
      fontSize: "1.5rem",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    amountTitle: {
      fontWeight: "bolder",
      fontSize: "1.175rem",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    normalTextAdmin: {
      fontSize: "0.95rem",
      fontWeight: "normal",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      textAlign: "start",
    },
    normalText: {
      fontSize: "0.95rem",
      fontWeight: "normal",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    voucherTitle: {
      fontSize: "0.95rem",
      fontWeight: "normal",
      fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    },
    textFieldErrorMessageStyle:{
      color:"red"
    }
    // demoStyle: {
    //   "&:hover": {
    //     backgroundColor:"green",
    //   }
    // }
  })
);